import script from "./SendTestEmailDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendTestEmailDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__